/**
 * Разбор входного URL вьюера. Контракт (ADR 0004, неизменен навсегда):
 * /v/{venue}?a={anchor}&to={poi}
 * Паттерн «мусор → null» — из TecTactic fromUri. Хост не проверяем: страница
 * уже отдана с нашего домена; сборка исходящих ссылок — venueUrl() в @app/brand.
 */

export interface VenueLink {
  readonly venueId: string
  readonly anchor?: string | undefined
  readonly to?: string | undefined
  /**
   * Сырой `&r=` — путь к выходу, зашитый в саму табличку (Google polyline,
   * точность 5). Добавочный параметр, как `?e=`: контракт ADR 0004 не меняется.
   * Разбор строки — decodePolyline(@app/geo) на стороне потребителя: здесь
   * сознательно не декодируем, чтобы разбор ссылки оставался без зависимостей.
   */
  readonly r?: string | undefined
}

export function parseVenuePath(pathname: string, search: string): VenueLink | null {
  const match = pathname.match(/^\/v\/([\w-]+)\/?$/)
  const venueId = match?.[1]
  if (!venueId) return null
  const params = new URLSearchParams(search)
  return {
    venueId,
    anchor: params.get('a') ?? undefined,
    to: params.get('to') ?? undefined,
    r: params.get('r') ?? undefined,
  }
}
